<template>
  <el-container v-wechat-title="title">
    <el-aside>
      <RouterMenu :menu-items="menuList">
        <template slot-scope="{item}">
          <i :class="item.icon" v-if="item.icon"></i>
          <span>{{item.display}}</span>
        </template>
      </RouterMenu>
    </el-aside>
    <el-main>
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
    name: `Settings`,
    data() {
        return {
            title: `配置`,
            menuList: [{
                name: `user`,
                route: { path: `/user` },
                display: `用户`,
                permission: `user:*`
            }, {
                name: `role`,
                route: { path: `/role` },
                display: `角色`,
                permission: `role:*`
            }, {
                name: `permission`,
                route: { path: `/permission` },
                display: `权限`,
                permission: `permission:*`
            }]
        }
    }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Settings/Index.vue